export type FormatAlign = 'start' | 'end';

export const formatWithSymbol = (
  value: number | string,
  symbol: string = ' ',
  charLength: number = 3,
  align: FormatAlign = 'end',
): string => {
  const sep = symbol;
  const n = charLength;

  const s = String(value).trim();
  if (!s) return s;

  const sign = s.startsWith('-') ? '-' : '';
  const raw = sign ? s.slice(1) : s;

  const [intPartRaw, fracPartRaw] = raw.split('.');

  const intDigits = intPartRaw.replace(/\D/g, '');
  if (!intDigits) return sign + raw;

  if (!Number.isInteger(n) || n <= 0) {
    const frac = fracPartRaw !== undefined ? fracPartRaw.replace(/\D/g, '') : undefined;
    return sign + (frac !== undefined ? `${intDigits}.${frac}` : intDigits);
  }

  let formattedInt = '';

  if (align === 'start') {
    // Group from START: 123456 with n=4 => 1234-56
    const parts: string[] = [];
    for (let i = 0; i < intDigits.length; i += n) {
      parts.push(intDigits.slice(i, i + n));
    }
    formattedInt = parts.join(sep);
  } else {
    // Group from END: 1234567 with n=3 => 1 234 567
    const len = intDigits.length;
    const first = len % n || n; // first group length
    const parts: string[] = [intDigits.slice(0, first)];
    for (let i = first; i < len; i += n) {
      parts.push(intDigits.slice(i, i + n));
    }
    formattedInt = parts.join(sep);
  }

  const frac = fracPartRaw !== undefined ? fracPartRaw.replace(/\D/g, '') : undefined;
  return sign + (frac !== undefined ? `${formattedInt}.${frac}` : formattedInt);
};